import React, { Component } from 'react';
import {
    BackTop,
    Button, Table, Menu, Space, Select, Tag, Row, Col, Card, DatePicker, Input, Tooltip, Typography, Tabs, Avatar, Affix
} from 'antd'

import { PlusOutlined, MinusOutlined, ReloadOutlined, ClockCircleOutlined, CloseOutlined, DownOutlined } from '@ant-design/icons';

import { Link } from 'react-router-dom';

import { toJS, _getAdministration } from "mobx";
import { inject, observer } from 'mobx-react';

import _, { parseInt, times, conforms } from 'lodash';
import moment from 'moment';
import { LoadingGlobal } from '../components/LoadingGlobal';
//moment.locale('tr')
//import 'moment/locale/tr';

const queryString = require('query-string');

import NavbarMenu from '../components/NavbarMenu';
import { dateFormatedYMD } from '../helper';
const { TabPane } = Tabs;

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Text, } = Typography;
const { SubMenu } = Menu;

@inject('HourseBetStore', 'GeneralStore')
export default class Result extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            ganyanList: [
                { title: "6'lı Ganyan", key: "6g", count: 6, selected: true, available: false },
                { title: "5'li Ganyan", key: "5g", count: 5 },
                { title: "4'lü Ganyan", key: "4g", count: 4 },
                { title: "3'lü Ganyan", key: "3g", count: 3 },
                { title: "Tabela", key: "T", count: 2, unitPrice: 1, available: false, desc: "En az 4 atın koştuğu koşudan birinci ve ikinciyi bulmak gerekiyor." },
                { title: "Çifte Bahis", key: "C", count: 2, unitPrice: 1, available: false, desc: "En az 4 atın koştuğu koşudan birinci ve ikinciyi bulmak gerekiyor." },
                { title: "Ganyan/Plase", key: "G", count: 2, unitPrice: 1, available: false, desc: "En az 4 atın koştuğu koşudan birinci ve ikinciyi bulmak gerekiyor." },
                { title: "İkili Bahis", key: "I", count: 2, unitPrice: 1, available: false, desc: "En az 7 atın koştuğu koşudan birinci ve ikinciyi bulmak gerekiyor." },
                { title: "Sıralı İkili Bahis", key: "Io", count: 2, unitPrice: 1, available: false, desc: "En az 4 atın koştuğu koşudan birinci ve ikinciyi bulmak gerekiyor." },
            ],
            couponSubTypes: [
                { title: "1-2-3-4-5-6", key: "6g", count: 7, selected: true, available: false },
            ],
            modalVisible: false,
            modalOpenCreate: false,

            nowDate: Date.now(),
            //      selectedArea: this.props.GeneralStore.races[0],
            selectedRaceIn: null,
            selectedKosu: null,
            raceData: [],
        }

    }


    componentDidMount() {
        this.interval = setInterval(() => this.setState({ nowDate: Date.now() }), 50000);


        const parsedHash = queryString.parse(location.search);
        const KEY = _.get(parsedHash, "KEY")
        const date = _.get(parsedHash, "date")
        const run = _.get(parsedHash, "run")

        console.log({
            KEY,
            date,
            run
        })

        //         const myDate = dateFormatedYMD(date ? new Date().setDate(date) : Date.now())

        this.getItems(null, date, KEY, run)
    }



    componentWillUnmount() {
        clearInterval(this.interval);
    }

    //itemleri getir (init)
    getItems = async (date = null, formatedDate = "", KEY = "", run = "") => {
        let myDate = dateFormatedYMD(date ? new Date().setDate(date) : Date.now())
        if (formatedDate) myDate = formatedDate
        this.setState({ loading: true })
        try {
            const serverData = await this.props.HourseBetStore.getResult(myDate)
            let data = _.get(serverData, "data.program", [])
            console.log("getItems", { serverData, data })
            this.setState({ data })
            this.initSelectedData(KEY, run)
        } catch (error) {
            const statusCode = _.get(error, "response.status")
            if (statusCode == 404) {
                this.setState({ statusCode })
            }
            console.log({ error, statusCode })
            //  this.getItems()
        }
        finally {
            this.setState({ loading: false })
        }
    }



    initSelectedData = (KEY, NO) => {
        const data = _.get(this.state, "data", [])
        if (data.length > 0) {

            if (KEY) {
                const firstDataItem = _.find(data, { KEY })
                if (firstDataItem) {
                    firstDataItem.selected = true
                    const run = _.find(firstDataItem.kosular, { NO: _.toString(parseInt(NO)) })
                    if (run) {
                        run.selected = true
                    }
                    else {
                        firstDataItem.kosular[0].selected = true
                    }
                }

            }
            else {
                const firstDataItem = data[0]
                firstDataItem.selected = true
                firstDataItem.kosular[0].selected = true
            }

            this.setDate()
        }

    }

    setDate = () => {
        //this.setState({ data: _.orderBy(this.state.data, ['SIRA', { 'KEYtoSort': Number }], 'asc') })
        this.setState({ data: _.orderBy(this.state.data, ['SIRA'], 'asc') })
    }

    // ko0şuları mantıklı bir şekilde seç
    initSelectKosular = () => {
        //klonlama olayı
        const runArray = _.get(this.state.selectedBahis, "children.array", [])[0]
        console.log({ runArray, b: this.state.selectedBahis })
        this.onClickTabKosu({ NO: runArray.toString() })
    }


    //koşular tıklandığında (TAB)
    onClickTabKosu = (item, obj) => {
        // onClick={() => { this.onClickTabKosu({ NO: `${v.NO}-1at` }) }}
        const selectedBahis = this.state.selectedBahis
        const value = _.get(selectedBahis, "value", "")
        console.log("onClickTabKosu", { item, value })



        const fData = _.find(_.get(this.getSelectedData(), "kosular", []), (o) => {
            return o.NO === item.NO
        })
        if (fData) {

            _.get(this.getSelectedData(), "kosular", []).map(v => { v.selected = false }) // tüm koşuların seçili durumunu false yap
            fData.selected = true
            this.setState({ data: this.state.data })
        }
        console.log({ selectedBahis })

    }





    //hiponrom yeri tıklandığında
    onClickHipodromArea = (item) => {

        console.log(item)

        const { data } = this.state
        data.map(v => { v.selected = false })
        let selectedItem = _.find(data, (o) => {
            return _.get(o, "KEY", "") === _.get(item, "KEY", "")
        })
        //eğer seçili item varsa
        if (selectedItem) {
            selectedItem.selected = true
            const isSelectedRun = _.find(_.get(selectedItem, "kosular", []), { selected: true })
            //eğer seçilen hiponromun seçili koşusu yoksa, seçili hale getir
            if (!isSelectedRun) {
                const firstRun = _.get(selectedItem, "kosular", [])
                if (firstRun.length > 0) {
                    firstRun[0].selected = true
                }
            }
            this.setState({ data: this.state.data }, () => {
            })
        }

    }

    //seçili data
    getSelectedData = () => {
        const { data } = this.state
        return _.find(data, { selected: true })
    }

    //seçili koşu
    getSelectedKosu = () => {
        return _.find(_.get(this.getSelectedData(), "kosular", []), { selected: true })
    }


    //seçili koşu field ini getir
    getSelectedKosuField = (fieldName) => {
        return _.get(this.getSelectedKosu(), fieldName, "")
    }
    //ganyanm tipi tıklandığında
    onClickGanyanType = (v) => {
        const { ganyanList } = this.state
        const fItem = _.find(ganyanList, { key: v.key })
        ganyanList.map(v => v.selected = false)
        fItem.selected = true
        this.setState({ ganyanList, showGanyanDropdownList: false })
    }

    ///   #########
    //tüm koşuların atlarını getir
    getAtlarWithKosu = (i) => {
        const kactan = i
        //  return _.get(this.getSelectedData(), "kosular", [])[kactan]
        return _.find(_.get(this.getSelectedData(), "kosular", []), { NO: kactan.toString() })
    }


    //max agf getir
    getMaxAgfValue = (indexRun = null) => {

        //maximum değer
        const maxxAgf = _.maxBy(_.get(indexRun ? this.getAtlarWithKosu(indexRun) : this.getSelectedKosu(), "atlar", []), (o) => {
            return parseInt(o.AGF1)
        })
        return _.get(maxxAgf, "KEY")
    }


    /******AGA */
    //seçili datanın bahisleri
    getSelectedDataBet = () => {
        const data = this.getSelectedData()
        const bahisler = _.find(_.get(this.state.bahisler, "hippodromes"), (o) => {
            return o.value === _.get(data, "KEY")
        })
        return bahisler
    }

    thisGetSelectedKey = () => {

    }

    //atın agf sini getir
    gethourseAgf = (hourse) => {
        const getSelectedKosu = this.getSelectedKosu()
        const getSelectedData = this.getSelectedData()

        const kosular = _.get(getSelectedData, "kosular", [])
        const { data } = this.state
        let agfs = _.get(getSelectedData, "agf", [])
        const concatAgfs = _.concat(...agfs)
        console.log({ agfs, concatAgfs, aaa: _.concat(agfs[0], agfs[1]), getSelectedKosu, data, getSelectedData })

    }


    // bahisler butonu tıklandığında
    onClickBetMenu = (item) => {
        console.log("onClickBetMenu", { item })
        item.children = item.races[0]
        // this.setState({ selectedBahis: item })
        this.afterİnitBahis(item)
    }
    onClickBetMenuChildren = (item) => {
        console.log("onClickBetMenuChildren", { item })
        this.state.selectedBahis.children = item
        //  this.setState({ selectedBahis: this.state.selectedBahis })
        this.afterİnitBahis(this.state.selectedBahis)
    }

    render() {
        const { data, ganyanList, loading, nowDate } = this.state



        return (
            <div
            >
                <LoadingGlobal loading={loading} />
                <main>
                    {/* Bahiis Yap */}
                    <main>
                        <div

                            style={{
                                backgroundColor: '#f02'
                            }}
                        // style={{
                        //     backgroundColor: '#FF0020',
                        //     marginBottom: '.75rem',
                        //     padding: '5px 0',
                        // }}
                        >

                            <div className="row no-gutters">
                                <div className="col">
                                    <NavbarMenu />
                                </div>
                            </div>

                        </div>


                        <div className="row no-gutters">
                            <div className="col-2">

                            </div>

                            <div className="col">
                                <div style={{ marginLeft: '-15px', color: '#FFF', padding: '2px' }}>
                                    <div className="p-2 bg-black text-white p13">

                                        <span className="font-xsm font-weight-normal mr-3">
                                            <strong> {_.get(this.getSelectedData(), "YER", "")}</strong>
                                            {` / `}
                                            {_.get(this.getSelectedData(), "AD", "")}
                                        </span>

                                        <span data-bet-server-timer className="float-right font-xsm font-weight-normal opacity-08">
                                            {new Date().getDate()}
                                            {` `}
                                            {moment(new Date()).format("MMMM")}
                                            {` `}
                                            {moment(new Date()).format("dddd")}
                                            {` `}
                                            {` ${new Date(nowDate).getHours()}:${new Date(nowDate).getMinutes()}`}
                                        </span>
                                    </div>

                                </div>
                            </div>

                        </div>

                        <div className="row" data-page="bet-page" style={{ width: '100%' }}>

                            <div className="col-2">
                                <div className="row no-gutters mb-3" >
                                    <select
                                        defaultValue={new Date().getDate()}
                                        className="ptarih"
                                        onChange={(e) => this.getItems(e.target.value)}
                                    >
                                        <option value={new Date().getDate() - 1}>Dün</option>
                                        <option value={new Date().getDate()}>Bugün</option>
                                    </select>
                                </div>

                                <div className="row no-gutters mb-3" >
                                    {
                                        data.map((v, i) => {
                                            return (
                                                <div key={i} className="col-6">
                                                    <a
                                                        onClick={() => this.onClickHipodromArea(v)}
                                                        className={`btn btn-glossred  w-100 rounded-0 ${v.selected ? "selected-ganyan-title" : ""}`}>
                                                        {_.get(v, "YER", "")}
                                                    </a>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>

                            <div className="col-10 card w-100 mb-3 border-0 rounded-0 " data-panel-id="bet-table" data-selector="betContent">
                                <div className="card-body p-0 bet-table-container" data-selector="bet-table-container">
                                    <nav className="m-0">
                                        <div className="nav nav-tabs bet-tab" role="tablist" data-selector="raceTabs">
                                            {

                                                _.get(this.getSelectedData(), "kosular", []).
                                                    map((v, i) => {
                                                        return (
                                                            <a key={i}
                                                                onClick={() => { this.onClickTabKosu(v) }}
                                                                className={`nav-item nav-link border-0 tabcolor-${_.get(v, "ActiveClass", "")} font-sm ${v.selected ? "active" : ""}`}>
                                                                {v.NO}.Koşu

                                                            </a>
                                                        )
                                                    })
                                            }
                                        </div>
                                    </nav>
                                    <div className="tab-content bet-tabs" data-selector="betTableContainer">
                                        <div className="tab-pane fade show active" id="bet-1" role="tabpanel" aria-labelledby="bet-1-tab">
                                            <div className={`text-white bg-${_.get(this.getSelectedKosu(), "ActiveClass", "")}`}>
                                                <div className="row p-2 pl-3 pr-3 no-gutters">
                                                    <div className="col col-11 font-xsm">
                                                        <span data-selector="allTabsShow"
                                                        //className="d-none"
                                                        >{this.getSelectedKosuField("RACENO")}.Koşu &nbsp;|&nbsp; </span>
                                                        {this.getSelectedKosuField("SAAT")}
                                &nbsp;|&nbsp; {`${this.getSelectedKosuField("MESAFE")} ${this.getSelectedKosuField("PISTADI_TR")}`} &nbsp;|&nbsp; {this.getSelectedKosuField("GRUP_TR")} &nbsp;|&nbsp;
                                {this.getSelectedKosuField("CINSDETAY_TR")}
                                                        <br />
                                                        <span className="text-white">
                                                            {this.getSelectedKosuField("ENIYIDERECEACIKLAMA")}
                                                        </span>
                                                    </div>
                                                    <div className="col text-right">
                                                        <a href="#" data-button-race-info={1}>
                                                            <i className="icon-info text-white" />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="table-container bet-table">
                                                <table className="table table-sm table-striped table-hover w-100">
                                                    <thead>
                                                        <tr className="text-truncate text-center font-xsm">
                                                            <th />
                                                            <th />
                                                            <th className="text-left">At İsmi</th>
                                                            <th>Yaş</th>
                                                            <th className="text-left px-0">Orijin (Baba-Anne)</th>
                                                            <th className="text-left">Kilo</th>
                                                            <th className="text-left">Jokey</th>
                                                            <th className="text-left px-0">Sahip/Antrenör</th>
                                                            <th>St</th>
                                                            <th>Hp</th>
                                                            <th>Son 6</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="selected-bg-sand">
                                                        {
                                                            _.get(this.getSelectedKosu(), "atlar", []).map((v, i) => {
                                                                return (
                                                                    <tr key={i}
                                                                        className={`text-truncate text-center ${_.get(v, "KOSMAZ", false) ? "disabled-horse" : ""} ${_.get(v, "selected", false) ? "selected" : ""}`} >
                                                                        <td className="bet-checkbox checkbox-color-default align-middle">
                                                                            {
                                                                                v.KOSMAZ ?
                                                                                    <div>
                                                                                        <CloseOutlined style={{ color: 'red' }} />
                                                                                    </div>
                                                                                    :
                                                                                    <div className="custom-control custom-checkbox">
                                                                                        <label className={`custom-control-label ${v.SONUC == "1" ? "selected" : ""}`} data-no={v.NO} />
                                                                                    </div>
                                                                            }

                                                                        </td>
                                                                        <td>
                                                                            <div className="forma-img" style={{ backgroundImage: `url(${_.get(v, "FORMA", "").substring(29) ? `https://medya-cdn.tjk.org/formaftp/${_.get(v, "FORMA", "").substring(29)}` : "https://ebayi.tjk.org/dist/images/no-uniform.jpg"})` }} />
                                                                        </td>
                                                                        <td className="text-left font-weight-bold">
                                                                            <a className="text-dark"><u className="text-decoration-none" >
                                                                                {_.get(v, "AD", "")}
                                                                                {` `}
                                                                                <span className="text-red">({v.SONUC})</span>

                                                                            </u></a>
                                                                            <br />
                                                                            <span className="text-red font-weight-normal font-xxsm" >{_.get(v, "TAKI", "")}</span>
                                                                        </td>
                                                                        <td className="align-middle font-xxsm">{_.get(v, "YAS", "")}</td>
                                                                        <td className="align-middle text-left font-xxsm px-0">
                                                                            <span className="text-blue" >{_.get(v, "BABA", "")}</span>
                                                                            <br />
                                                                            <span className="text-red" >{_.get(v, "ANNE", "")}</span>
                                                                            <span className="text-red" >{_.get(v, "ANNEBABA", "")}</span>
                                                                        </td><td className="align-middle text-left font-xxsm text-center">{_.get(v, "KILO", "")}</td>
                                                                        <td className="align-middle text-left font-xxsm">
                                                                            <span >{_.get(v, "JOKEYADI", "")}</span>
                                                                        </td>
                                                                        <td className="align-middle text-left px-0">
                                                                            <span className="font-xxsm" >{_.get(v, "SAHIPADI", "")}</span>
                                                                            <br />
                                                                            <span className="font-xxsm" >{_.get(v, "ANTRENORADI", "")}</span>
                                                                        </td>
                                                                        <td className="align-middle font-xxsm">{_.get(v, "START", "")}</td>
                                                                        <td className="align-middle font-xxsm">{_.get(v, "HANDIKAPPUAN", "")}</td>
                                                                        <td className="align-middle font-xxsm">
                                                                            {_.get(v, "SON6_ARR", []).map((v, i) => {
                                                                                return (
                                                                                    <span key={i} className="text-success" style={{ margin: '0 -1px' }}> {_.get(v, "text", "")}</span>
                                                                                )
                                                                            })}
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>



                                            <div className="font-sm bg-yellow p-2">
                                                {_.get(this.getSelectedKosu(), "BAHISLER_TR", "")}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </main>
                </main>
            </div>
        )


    }
}